// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { flashMessageActionCreators, qrActionCreators } from '../../actions';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';
import { __ } from '../../i18n/l10n';
import { FlashMessageScopes, FlashMessageSeverities, FlashMessageTypes } from '../../types/flashmessage';

import QRScanner from './QRScanner';

type QRScannerContainerProps = {
  className?: string;
};

const QRScannerContainer = (ownProps: QRScannerContainerProps) => {
  const { history, location } = useRouter();
  const dispatch = useDispatch();

  const actionsProps = useBindActionsCreator(qrActionCreators);

  const onScanSuccess = useCallback(() => history.goBackOrReplace(location.pathname), [history, location]);
  const onWrongQRCode = useCallback(() => {
    dispatch(
      flashMessageActionCreators.addMessage({
        scope: FlashMessageScopes.QR,
        severity: FlashMessageSeverities.ERROR,
        type: FlashMessageTypes.DISMISS_AUTO,
        message: __('This QR code is not a Winamax bonus code'),
      }),
    );
  }, [dispatch]);
  const otherProps = useMemo(
    () => ({
      onScanSuccess,
      onWrongQRCode,
    }),
    [onScanSuccess, onWrongQRCode],
  );
  const enhancedProps = useMergeProps({ ownProps, actionsProps, otherProps });

  return <QRScanner {...enhancedProps} />;
};

export default QRScannerContainer;
